import { ACH_FORM } from './documentForms';

export enum DocumentName {
  DEAL_ECONOMICS = 'Deal Economics',
  REQUESTED_CLOSING_DATE = 'Requested Closing Date',
  EXPECTED_CLOSING_DATE = 'Expected Closing Date',
  TRACKING_NUMBER = 'Tracking Number',
  DUE_DILIGENCE_PAYMENT = 'Due Diligence Payment',
  APPRAISAL_ORDER_DETAILS = 'Appraisal Order Details',
  APPRAISAL_DETAILS = 'Appraisal Details',
  LOAN_FAST_TRACK_PAYMENT = 'Loan Fast Track Payment',
  TERM_SHEET = 'Term Sheet',
  BORROWER_SURVEY_QUESTIONNAIRE = 'Borrower Survey Questionnaire',
  BORROWER_ENTITY = 'Borrower Entity Information',
  LENDER_FEES = 'Lender Fees',
  TITLE_AGENT = 'Title Provider Information',
  INSURANCE_PROVIDER = 'Insurance Provider Information',
  EXPECTED_WIRE_RELEASE_DATE = 'Expected Wire Release Date',
  CLOSING_REVIEW = 'Closing Review',
  SIGNED_CLOSING_DOCUMENTS_REVIEW = 'Signed Closing Documents Review',
  TITLE_DOCUMENTS_REVIEW = 'Title Documents Review',
  POST_CLOSING_REVIEW = 'Post QC Review',
  INSURANCE_APPROVAL = 'Insurance Approval',
  INSURANCE_INFORMATION = 'Insurance Information',
  INSURANCE_INFORMATION_REVIEW = 'Insurance Information Review',
  LOAN_FUNDING_TEMPLATE = 'Loan Funding Template',
  APPRAISAL = 'Appraisal',
  APPRAISAL_REPORT = 'Appraisal Report',
  APPRAISAL_REPORT_AS_IS_RENT = 'Appraisal Report (As-Is w/ Rent Schedule)',
  APPRAISAL_REPORT_ARV = 'Appraisal Report (ARV)',
  APPRAISAL_REPORT_AS_IS = 'Appraisal Report (As is)',
  APPRAISAL_RESOLUTIONS = 'Appraisal Resolutions',
  RENT_SCHEDULE = 'Rent Schedule',
  BORROWER_CLOSING_AGENT = 'Borrower Closing Agent Information',
  SCOPE_OF_WORK = 'Scope of Work',
  DIGITAL_SCOPE_OF_WORK = 'Digital SOW',
  DEAL_SUMMARY = 'Deal Summary',
  PLAID_BANKS = 'Bank Information via Plaid',
  NOTE_ALLONGE = 'Note Allonge',
  ASSIGNMENT_AND_CONVEYANCE = 'Assignment and Conveyance',
  NOTE_ALLONGE_WET_SIGN = 'Note Allonge - WS',
  ASSIGNMENT_AND_CONVEYANCE_WET_SIGN = 'Assignment and Conveyance - WS',
  RECEIPT_CONFIRMATION_WET_SIGN = 'Confirmation of Receipt - WS',
  FUNDING_PREFERENCE = 'Loan Closing Data',
  RATE_LOCK_EXTENSION = 'Rate Lock Extension',
  POINT_OF_CONTACT = 'Point of Contact',
  PROPERTY_PHOTOS = 'Property Photos',
  DRAW_REQUEST_FORM = 'Draw Request Form',
  REVISED_SOW = 'Revised SOW',
  REVISED_SOW_FORM = 'Revised SOW Form',
  HUD = 'HUD',
  ADDITIONAL_CLOSING_REVIEW = 'Additional Closing Review',
  TITLE_COMPANY_BANK_INFORMATION = 'Title Company Bank Information',
  DRAW_REPORT = 'Draw Report',
  BORROWER_BACKGROUND_REVIEW = 'Borrower Background Review',
  BORROWER_CREDIT_REVIEW = 'Borrower Credit Review',
  TRACK_RECORD_REVIEW = 'Borrower Track Record Review',
  TRACK_RECORD = 'Track Record',
  CERTIFICATE_OF_GOOD_STANDING = 'Certificate of Good Standing(+1yr)',
  FINAL_PAYOFF_REPORT = 'Final Payoff Report',
  CREDIT_REPORT = 'Credit Report',
  TRIMERGE_CREDIT_REPORT = 'Trimerge Credit Report',
  EXTENSION_DETAILS = 'Extension Details',
  EXTENSION_AGREEMENT = 'Extension Agreement',
  CLOSING_CONDITION_SUFIX = 'Closing Condition - ',
  ACH_FORM = 'ACH Consent Form',
  BORROWER_SETUP = 'Borrower Setup',
  CREDIT_AUTHORIZATION = 'Credit Authorization',
  BORROWER_IDENTITY_VERIFICATION = 'Borrower Identity Verification',
  APPRAISAL_REVIEW_REPORT = 'Appraisal Review Report',
  REFERRAL_INFORMATION = 'Off Hud Broker ACH',
  BORROWER_PAST_LOAN_DOCUMENTS = 'Borrower Past Loan Documents',
  PERSONAL_IDENTIFICATION = 'Personal Identification',
  CONSTRUCTION_FEASIBILITY_REVIEW = 'Construction Feasibility Review',
  APPRAISAL_LICENSE = 'Appraisal Licence',
  APPRAISAL_E_AND_O_POLICY = 'Appraisal E&O Policy',
  INTERNAL_VALUATION_REPORT = 'Valuation Team Report',
  PERMITS = 'Architect Letter Or Permits',
  BACKGROUND_REPORT = 'Background Report',
  DRAW_INFORMATION = 'Draw Information',
  WIRE_AUTHORIZATION = 'Wire authorization',
  INSPECTION_INVOICE_DETAILS = 'Inspection Invoice Details',
  INTERNAL_VALUATION = 'RealVal Fee',
  TAKE_PROPERTY_PHOTOS = 'Take Property Photos',
  SITE_INSPECTION_CM_REPORT = 'Site Inspection & CM Report',
  CONFIRM_LOAN_TERMS = 'Confirm Loan Terms',
  SERVICER_FEES = 'Servicer Fees',
  PAYOFF_REQUEST_DETAILS = 'Payoff Request Details',
  SERVICER_PROVIDED_DATA = 'Servicer Provided Data',
  INTEREST_ALLOCATION = 'Interest Allocation',
  FORECLOSURE_INTEREST_ALLOCATION = 'Foreclosure Interest Allocation',
  PAYOFF_CORRECTION = 'Payoff Correction',
  PAYABLE_ATTESTATION = 'Payable Attestation',
  DQ_TAXES_ATTESTATION = 'DQ Taxes Attestation',
  PAYOFF_CALCULATOR = 'Payoff Calculator',
  TAKE_INTERNAL_VALUATION_PHOTOS = 'RealVal Property Photos',
  TAKE_INTERNAL_VALUATION_PHOTOS_MANUAL = 'RealVal Property Photos (Manual)',
  TAKE_INTERNAL_VALUATION_PHOTOS_APPRAISAL = 'RealVal Property Photos (Appraisal)',
  CONFIRM_FIRST_APPRAISAL_VALUE = 'Confirm First Appraisal Value',
  PAYOFF_RECONCILIATION_REVIEW = 'Payoff Reconciliation Review',
  PAYOFF_REVIEW = 'Payoff Review',
  PAYOFF = 'Payoff',
  UNDERWRITE_THE_LOAN = 'Underwrite The Loan',
  ACCEPT_LOAN_TERMS = 'Accept Loan Terms',
  GOOD_FAITH_DEPOSIT = 'Good Faith Deposit',
  VALUATION_DETAILS = 'Valuation Details',
  INSURANCE_DOCUMENT = 'Insurance Document',
  SETTLEMENT_DETAILS = 'Settlement Details',
  TITLE_AGENCY = 'Title Agency',
  REALIZED_LOSS = 'Realized Principal And Interest Loss',
  DELINQUENCY_STATUS = 'Delinquency Status And Comments',
  POST_MORTEM = 'Post-Mortem',
  PROPERTY_APPRAISALS = 'Property Appraisals',
  PROPERTY_VALUATIONS = 'Appraisal Valuation',
  FORECLOSURE_ATTORNEY = 'Foreclosure Attorney',
  FORECLOSURE_STAGES = 'Foreclosure stages',
  VALUATION_PAYMENT = 'Valuation Payment',
  APPRAISAL_RECERTIFICATION = 'Appraisal Recertification',
  TRACK_RECORD_RESOLUTION = 'Track Record Resolution',
  PROPERTY_RESOLUTION = 'Property Resolution',
  PRESCREEN = "Prescreen",
  CLIENT_VALUATION_DISPUTE = 'Client Valuation Dispute',
  INTERNAL_VALUATION_ROV_FOR_APPRAISAL = 'Internal Valuation ROV for Appraisal',
  INSURANCE_DETAILS = 'Insurance Details',
  TITLE_COMMITMENT = 'Title Commitment',
  PROOF_OF_RECEIPT = 'Proof of Receipt of Rental Income for Most Recent 3 Months',
  TAX_CERTIFICATE = 'Tax Certificate',
  BORROWER_LIQUIDITY = 'Borrower Liquidity',
  LEASE_AGREEMENT = 'Lease Agreement',
  UW_HUD = 'HUD or Other Documentation of Property Ownership (Refi Only)',
  HUD_DOC = 'HUD (Refi Only)',
  HOA = 'HomeOwners Association (HOA) Fee Document',
  VERIFICATION_OF_MORTGAGE = 'Verification of Mortgage - (VOM)',
  PURCHASE_CONTRACT = 'Purchase Contract with all Addendums',
  WHOLESALER_CONTRACT = 'Wholesaler Contract or Assignment of Bid',
  APPRAISAL_REASSIGNMENT_LETTER = 'Appraisal Reassignment Letter',
  ORIGINATOR_STATE_LICENSE = 'Originator State License',
  COMPANY_STATE_LICENSE = 'Company State License',
  CLOSING_INSTRUCTION_LETTER = 'Closing Instruction Letter',
  CLOSING_PROTECTION_LETTER = 'Closing Protection Letter (CPL)',
  GC_LICENSE = 'GC License',
  BROKER_LICENSE = 'Broker License',
  FINAL_TITLE_POLICY = 'Final Title Policy',
  RECORDED_MORTGAGE = 'Recorded Mortgage',
  RECORDED_ALR = 'Recorded ALR',
  CERTIFICATE_OF_FORMATION = 'Certificate of Formation (LLC)',
  OPERATING_AGREEMENT = 'Operating Agreement (LLC)',
  BYLAWS = 'Bylaws (Corp)',
  BORROWING_CORP_STOCK_CERTIFICATE = 'Borrowing Corp Stock Certificate',
  FILING_RECEIPT = 'Filing Receipt',
  ARTICLES_OF_INCORPORATION = 'Articles of Incorporation (Corp)',
  CERTIFICATE_OF_GOOD_STANDING_BASE = 'Certificate of Good Standing',
  CERTIFICATE_OF_EXISTENCE = 'Certificate of Existence',
  BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING = 'Borrower LLC Certificate of Good Standing',
  FOREIGN_ENTITY_REGISTRATION = 'Foreign Entity Registration',
  RECORDED_UCC1_STATE = 'Recorded UCC1- State',
  RECORDED_UCC1_COUNTY = 'Recorded UCC1- County',
  SELLER_ENTITY_DOCUMENTS = 'Seller Entity Documents',
  EIN_LETTER = 'EIN Letter',
  RECORDED_CEMA = 'Recorded CEMA',
  RECORDED_BUILDING_MORTGAGE = 'Recorded Building Mortgage',
  UNCLASSIFIED_DOCUMENTS = 'Unclassified Documents',
}

export enum ResolutionType {
  LIEN = 'LIEN'
}

export enum DocumentSection {
  INSURANCE = 10,
}

export enum DocumentSectionNames {
  GENERATED_CLOSING_DOCUMENTS = 'Generated Closing Documents',
  BOARDING = 'Boarding',
  SCANNED_CLOSING_DOCS = 'Scanned Closing Docs',
  RECORDED_CLOSING_DOCS = 'Recorded Closing Docs',
  PHYSICAL_ORIGINAL_RECORDED_CLOSING_DOCS = 'Physical Original Recorded Closing Docs',
  E_FILE_ONLY_RECORDED_CLOSING_DOCS = 'E-file Only Recorded Closing Docs',
  POST_CLOSING = 'Post Closing',
  DELINQUENCY_MANAGEMENT = 'Delinquency Management',
  APPRAISAL_AND_SOW = 'Appraisal And Sow',
  OTHER = 'Other',
  CLOSING_DOCUMENTS = 'Closing Documents',
  SIGNED_CLOSING_DOCUMENTS = 'Signed Closing Documents',
  INSURANCE = 'Insurance',
  TRAILING_DOCUMENTS = 'Trailing Documents',
}

export enum DocumentFilter {
  ALL_DOCUMENTS = 'All Documents',
  PENDING_DOCUMENTS = 'Pending Documents',
}

export enum AIDocType {
  CLOSING_DOCS = 'Closing Docs',
  INSURANCE_REVIEW = 'Insurance Review',
  TITLE = 'Title',
  ENTITY = 'Entity',
  POST_CLOSING_REVIEW = 'Post-Closing Review'
}

export enum PostClosingReviewGroup {
  TITLE = 'Title',
  ENTITY = 'Entity',
  INSURANCE = 'Insurance',
}

export const DONT_DELETE_EXCLUDE_DOCUMENTS = [DocumentName.APPRAISAL_LICENSE, DocumentName.APPRAISAL_E_AND_O_POLICY]

export const QUOTE_LOANS = ['Fix and Flip (1-4)', 'Fix and Flip Pro (1-4)', 'Groundup (1-4)', 'Stabilized Bridge'];

export const restrictedAppraisalDocuments: Array<String> = [
  DocumentName.APPRAISAL,
  DocumentName.APPRAISAL_REPORT,
  DocumentName.APPRAISAL_REPORT_AS_IS_RENT,
  DocumentName.APPRAISAL_REPORT_ARV,
  DocumentName.APPRAISAL_REPORT_AS_IS,
  DocumentName.APPRAISAL_RESOLUTIONS,
  DocumentName.RENT_SCHEDULE
];

export const isBgOrCredit: Array<String> = [
  DocumentName.CREDIT_REPORT,
  DocumentName.TRIMERGE_CREDIT_REPORT,
  DocumentName.BACKGROUND_REPORT
]
